<template>
    <b-card>
        <loading-card v-if="loaded == 0" />

        <div v-if="loaded > 0">
            <bar-chart :data="report" :options="options" />
        </div>
    </b-card>
</template>

<script>
import FormatsDates from "../../../mixins/FormatsDates";

export default {
    mixins: [ FormatsDates ],

    props: ['data'],

    data() {
        return {
            clientData: [],
            caregiverData: [],
            loaded: 0,
            report: {
                labels: ["0-15", "16-30", "31-60", "61-90", "91-120", "121+"],
                datasets: [{
                    label: 'Policy Holders',
                    data: [],
                    backgroundColor: 'rgba(38, 198, 218, 0.2)',
                    borderColor: 'rgba(38, 198, 218, 1)',
                    borderWidth: 2,
                }, {
                    label: 'Providers',
                    data: [],
                    backgroundColor: 'rgba(116, 96, 238, 0.2)',
                    borderColor: 'rgba(116, 96, 238, 1)',
                    borderWidth: 2,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                      scaleLabel: {
                        display: true,
                        labelString: 'Total users enrolled'
                      }
                    }],
                    xAxes: [{
                      scaleLabel: {
                        display: true,
                        labelString: 'Days since enrollment material sent'
                      }
                    }]
                }
            },
        };
    },

    computed: {
    },

    methods: {
        fetch() {
            this.loaded = 0;
            axios.get(this.url)
                .then( ({ data }) => {
                    this.items = data;
                    this.totalItems = this.items.length;
                    this.loaded = 1;
                })
        },

        update() {
            this.report = {
                labels: ["0-15", "16-30", "31-60", "61-90", "91-120", "121+"],
                datasets: [{
                    label: 'Policy Holders',
                    data: this.clientData,
                    backgroundColor: 'rgba(38, 198, 218, 0.2)',
                    borderColor: 'rgba(38, 198, 218, 1)',
                    borderWidth: 2,
                }, {
                    label: 'Providers',
                    data: this.caregiverData,
                    backgroundColor: 'rgba(116, 96, 238, 0.2)',
                    borderColor: 'rgba(116, 96, 238, 1)',
                    borderWidth: 2,
                }],
            };
        },
    },

    mounted() {
        this.loaded = 1;
        this.clientData = this.data.clients;
        this.caregiverData = this.data.caregivers;
        this.update();
    },
}
</script>
